import { DatePicker, DatePickerProps } from "@/ui/datepicker";

export default function DateFiled({
    onClear,
    placeholderText = "Select date",
    inputProps,
    ...props
}: DatePickerProps & { onClear?: () => void }) {
    return (
        <DatePicker
            monthsShown={1}
            placeholderText={placeholderText}
            inputProps={{
                inputClassName: "h-9 [&_input]:text-ellipsis",
                ...inputProps,
            }}
            className="w-72"
            {...props}
        />
    );
}
